const routes = [{
        path: "/mails/create",
        name: "mails_create",
        component: () =>
            import (
                "../components/gec/formModal/MailCreate.vue"
            ),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/mails",
        name: "mail_list",
        component: () =>
            import (
                "../components/gec/list/MailList.vue"
            ),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/mails/detail/:id",
        name: "mail_detail",
        component: () =>
            import (
                "../components/gec/detail/MailDetail.vue"
            ),
        meta: {
            requiresAuth: true
        }
    },

    {
        path: "/mails_exits",
        name: "mail_list_exit",
        component: () =>
            import (
                "../components/gec/list/MailListExit.vue"
            ),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/mails_internals",
        name: "mail_list_internal",
        component: () =>
            import (
                "../components/gec/list/MailListInternal.vue"
            ),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/mails/create/attached/:id",
        name: "mails_create_attached",
        component: () =>
            import (
                "../components/gec/formModal/MailCreateDetail.vue"
            ),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/mails_copies",
        name: "mail_list_copies",
        component: () =>
            import (
                "../components/gec/list/MailListCopy.vue"
            ),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/mails_copies/detail/:id",
        name: "mail_list_copies_details",
        component: () =>
            import (
                "../components/gec/detail/MailDetailCopy.vue"
            ),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/mails_opinion",
        name: "mails_opinion_list",
        component: () =>
            import (
                "../components/gec/list/MailListOpinion.vue"
            ),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/mails_opinion_return",
        name: "mails_opinion_return_list",
        component: () =>
            import (
                "../components/gec/list/MailListOpinionReturn.vue"
            ),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/mails_tracability",
        name: "mails_tracability_list",
        component: () =>
            import (
                "../components/gec/list/MailListTracability.vue"
            ),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/mails_topSecret",
        name: "mail_list_top_secret",
        component: () =>
            import (
                "../components/gec/list/MailListTopSecret.vue"
            ),
        meta: {
            requiresAuth: true
        }
    },
    {
      path: "/draft_response/:id",
      name: "draft_response",
      component: () =>
        import(
          "../components/gec/draft_response/DraftResponse.vue"
        ),
        meta: {
          requiresAuth: true
        }
    },
];

export default routes;